import { Component, OnInit } from '@angular/core';
import { PessoaFisicaOrgaoExpeditorLabels } from '@tivic-team/manager-ts/dist/grl/enums/pessoa-fisica-orgao-expeditor.enum';
import { ParentFormGroup } from 'app/tools/parent-formgroup';
@Component({
  selector: 'dropdown-orgao-expeditor-rg',
  templateUrl: './dropdown-orgao-expeditor-rg.component.html',
  styleUrls: ['./dropdown-orgao-expeditor-rg.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class DropdownOrgaoExpeditorRgComponent implements OnInit {

  orgaos

  constructor() { }

  async ngOnInit() {
    this.orgaos =  PessoaFisicaOrgaoExpeditorLabels
  }

}
